<template>
  <PrintInvoice />
</template>

<script>
import PrintInvoice from '../../components/invoice/invoicePrint'
export default {
  name: 'invoice-view',
  components: {
    PrintInvoice,
  },
}
</script>
